import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "@/components/CookieConsent";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#f5f4f1]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CookieConsent />
    </div>
  );
}
